// play videos
$('.videoblock-inline').each(function () { // get the iframe inside this slide.
    var player = $(this).find("iframe").get(0);
    command = {
        "event": "command",
        "func": "playVideo"
    };
    // check if the player exists.
    if (player != undefined) {
        $(this).find('.videoblock-overlay button').on("click", function (e) {
            $(this).parent().css('display', 'none');
            $(player).attr('aria-hidden', 'false');
            $(player).attr('tabindex', '0');
            let dataSource = $(player).data('src');
            // post our command to the iframe.
            $(player).attr('src', dataSource + "&autoplay=1");
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        });
    }
});
